module.exports = __webpack_public_path__ + "img/icon-banner-dex-safe.5f244053.svg";